import { render, staticRenderFns } from "./IpoAllocated.vue?vue&type=template&id=54e665a2"
import script from "./IpoAllocated.vue?vue&type=script&lang=js"
export * from "./IpoAllocated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports